export default "__VITE_ASSET__66ade296__"